import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

const reviews = [
  {
    name: '王先生',
    rating: 5,
    comment: '用了成全影院半年了，画质真的没得说，蓝光清晰度太赞了！而且完全没有广告打扰，观影体验一级棒。',
    date: '2025-07-20',
  },
  {
    name: '李女士',
    rating: 5,
    comment: '每天都来成全影院追剧，更新速度很快，新剧基本当天就能看。界面简洁干净，分类也很清晰，推荐给身边所有朋友了！',
    date: '2025-07-15',
  },
  {
    name: '张同学',
    rating: 5,
    comment: '作为大学生，免费观影真的太香了。成全影院片源丰富，从老片到新片都有，而且播放流畅不卡顿，宿舍网速也能流畅看高清。',
    date: '2025-07-10',
  },
  {
    name: '赵女士',
    rating: 4,
    comment: '全家都在用成全影院，老人喜欢看经典老片，孩子爱看动画片，我和老公追剧看电影，一个平台全搞定了。画质好又没有广告，真心推荐！',
    date: '2025-07-05',
  },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      if (honeypotInput) {
        formData.delete('phone_alt');
      }

      const response = await fetch('https://readdy.ai/api/form/d9oblukit35ii3jdm5bg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg: string = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

      if (response.ok && parsed && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        if (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('success');
          form.reset();
        } else {
          setFormStatus('error');
          setFormError(serverMsg || '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络后重试');
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 成全影院',
          description: '成全影院致力于提供高清画质流畅播放体验，无广告干扰，免费在线观看电影电视剧全集。了解我们的品牌故事与用户口碑。',
          url: 'https://chengquan.tv/about',
        }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-[1280px] mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="max-w-[800px] mx-auto text-center">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-4">
              关于成全影院
            </h1>
            <div className="w-16 h-1 bg-primary-500 mx-auto mb-6 rounded-full"></div>
            <p className="text-sm md:text-base text-secondary-600 leading-relaxed mb-4">
              成全影院成立于2020年，是一家专注于提供<strong>高清画质影视内容</strong>的在线平台。
              我们秉持"让每个人都能享受优质观影体验"的理念，致力于打造一个<strong>免费、纯净、流畅</strong>的影视观看环境。
            </p>
            <p className="text-sm md:text-base text-secondary-600 leading-relaxed mb-4">
              在成全影院，您可以在线观看最新电影和热门电视剧全集。我们采用先进的视频编码和CDN加速技术，
              确保您无论何时何地都能享受到<strong>蓝光画质、流畅不卡顿</strong>的观影体验。
            </p>
            <p className="text-sm md:text-base text-secondary-600 leading-relaxed">
              我们深知广告对观影体验的破坏，因此成全影院承诺<strong>全程无广告干扰</strong>，
              让您沉浸在纯粹的影视世界中。从动作大片到温馨喜剧，从科幻巨制到悬疑佳作，
              成全影院为您精选海量优质内容。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-[1000px] mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading mb-1">10000+</div>
                <p className="text-sm text-secondary-500">影视资源</p>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading mb-1">500万+</div>
                <p className="text-sm text-secondary-500">活跃用户</p>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading mb-1">99.9%</div>
                <p className="text-sm text-secondary-500">播放成功率</p>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading mb-1">0</div>
                <p className="text-sm text-secondary-500">广告干扰</p>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="max-w-[1000px] mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-secondary-500">
                听听用户们怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {reviews.map((review, index) => (
                <div key={index} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed mb-3">{review.comment}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{review.name}</span>
                    <span className="text-xs text-secondary-400 whitespace-nowrap">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-[600px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                联系我们
              </h2>
              <p className="text-sm text-secondary-500">
                有任何问题或建议，欢迎随时联系我们
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              data-readdy-form=""
              className="bg-background-50 border border-background-200/70 rounded-lg p-6"
            >
              <div className="flex flex-col gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">姓名</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">主题</label>
                  <input
                    id="contact-subject"
                    name="subject"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入主题"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（500字以内）"
                  ></textarea>
                  <p className="text-xs text-secondary-400 mt-1">最多500个字符</p>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="ab-addr"
                />
                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                >
                  {formStatus === 'loading' ? '提交中...' : '发送留言'}
                </button>
              </div>

              {formStatus === 'success' && (
                <div className="mt-4 p-3 bg-accent-100 text-accent-700 text-sm rounded-md text-center">
                  <i className="ri-check-line mr-1"></i>留言已发送，我们会尽快回复您！
                </div>
              )}
              {formStatus === 'error' && (
                <div className="mt-4 p-3 bg-primary-100 text-primary-700 text-sm rounded-md text-center">
                  <i className="ri-error-warning-line mr-1"></i>{formError || '提交失败，请稍后重试'}
                </div>
              )}
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}